import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet, NgIf } from '@angular/common';

@Component({
    selector: 'sh-content-context-notifications-layout',
    templateUrl: './content-context-notifications-layout.component.html',
    standalone: true,
    imports: [NgTemplateOutlet, NgIf]
})
export class ContentContextNotificationsLayoutComponent {
    @ContentChild('content') content: TemplateRef<any>;
    @ContentChild('context') context: TemplateRef<any>;

    @Input() className = 'sh-page-section--wide';
}
